<template>
  <div class="page page-Contacts" :class="{ loaded: isLoaded }">
    <div class="pictures m25">
      <div class="picture" :style="bgImgStyle(backgroundImages)"></div>
    </div>

    <div class="content m50">
      <VuePerfectScrollbar class="scroll-content" :settings="psSettings" v-if="!isMobile">
        <div class="text">
          <template v-for="(block, index) in _('blocks')">
            <div class="title" v-if="block.title" :key="index">{{ block.title }}</div>
            <p v-html="block.text" :key="index"></p>
          </template>
        </div>
      </VuePerfectScrollbar>

      <div v-if="isMobile">
        <template v-for="(block, index) in _('blocks')">
          <p v-html="block.textMobile" :key="index"></p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { loader } from '../mixins/loader';
import { isMobile } from '../mixins/isMobile';
import { functions } from '../mixins/functions';

export default {
  name: 'Contacts',
  mixins: [loader, isMobile, functions],

  data() {
    return {
      pageData: { page: 'Contacts' },
      backgroundImages: {},
      shownImage: 1,
      psSettings: {
        suppressScrollX: true
      }
    };
  },

  deactivated() {
    this.isLoaded = false;
  },

  activated() {
    var _t = this;

    if (
      _t.$store.state.pagesLoaded.App &&
      _t.$store.state.pagesLoaded.Contacts
    ) {
      _t.onActivated();
    } else {
      _t.$store.commit('loaderON');

      _t.$store.subscribe((mutation, state) => {
        if (
          mutation.type === 'pageLoaded' &&
          mutation.payload.page === 'Contacts'
        ) {
          _t.onActivated();
        }
      });
    }
  },

  created() {
    this.$store.dispatch('loadData', {
      page: 'Contacts'
    });
  },

  methods: {
    onActivated() {
      var _t = this;
      _t.backgroundImages = _t._('backgroundImages');

      if (_t.imagesLoaded) {
        _t.pageLoaded();
      } else {
        _t.loadImages(_t.backgroundImages);
      }
    },
    moveImage(delta) {
      let _t = this;

      if (delta === 'prev') {
        if (_t.shownImage !== 1) {
          --_t.shownImage;
        }
      } else {
        if (_t.shownImage !== _t.backgroundImages.length) {
          ++_t.shownImage;
        }
      }
    }
  }
};
</script>
